import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { useSnackbar } from 'notistack';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TTakingOverDefaultValues,
} from 'routes/Main/Survey/type';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import CommonPatientInfo from '../components/CommonPatientInfo';
import TextareaSection from '../components/TextAreaSection';

import { updateTakingOver } from 'apis/survey';

const TakingOver = (props: SurveyDialogProps<TTakingOverDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch } = useForm({
    defaultValues,
  });

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = (data: TTakingOverDefaultValues) => {
    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      take_over_survey: { ...data },
    };

    updateTakingOver(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('保存成功');
      })
      .catch(e => onFail('Failed to save', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          護理交接
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <TextareaSection
          {...formProps}
          title="意識水平 (LOC)"
          registerId="loc"
        />
        <TextareaSection
          {...formProps}
          title="生命徵象（具體）"
          registerId="vital_sign"
        />
        <TextareaSection
          {...formProps}
          title="目前情況 (手術後天數, 治療, 疼痛評估, 導管, 藥物, 特殊飲食等)"
          registerId="current_condition"
        />
        <TextareaSection
          {...formProps}
          title="約束 / 壓瘡 / 跌倒風險 / 隔離"
          registerId="rbfi"
        />
        <TextareaSection
          {...formProps}
          title="住院原因 / 病史 / 合併症 / 過敏"
          registerId="reasons"
        />
        <TextareaSection
          {...formProps}
          title="護理干預 (檢查, 治療, 其他科室請求等)"
          registerId="intervention"
        />
        <TextareaSection
          {...formProps}
          title="其他重要記錄"
          registerId="other"
        />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default TakingOver;
